<template>
  <div class="h-100">
    <div id="wrapper" class="col-md-10 mr-auto ml-auto" style="height:calc(100% - 63px);overflow:scroll;">

      <!-- Doctor details -->
      <transition enter-active-class="slideInUp">
        <div>
          <card v-if="!SPECIALITY_SELECTED">
            <div slot="header">
              <div class="row">
                <div class="col-8">
                  <h4 slot="header" class="card-title">
                    {{ $t("message.Doctor Details") }}
                  </h4>
                </div>
                <div class="col-4 text-right pt-2" v-if="DOCTOR_SELECTED">
                  <i class="fa fa-edit fa-2x text-muted" style="font-weight: 100" @click="showDoctorSelectionModal()"></i>
                </div>
              </div>
            </div>

            <div class="col-12 text-center" v-if="!DOCTOR_SELECTED" id="select-doctor-button">
              <n-button type="primary" round @click.native="(showDoctorSelectionModal())" id="btn-choose-doctor">
                <h6 class="m-0">
                  {{
                    $t("message.Choose Doctor")
                  }}
                </h6>
              </n-button>
            </div>

            <div v-if="DOCTOR_SELECTED">
              <doctor-details :doctor="selectedDoctor" :hideBillingDetails="true"></doctor-details>

              <div class="col-md-12 mt-2" v-if="appointment.scheduledTimestamp &&
                appointment.scheduledTimestamp.start
                ">
                <label class="">{{ $t("message.Consultation Date and Time") }}</label>
                <div class="col-12" style="font-size: 1rem">
                  {{ appointmentDate }}, {{ appointmentTime }}
                </div>
              </div>

              <div class="col-12 text-center">
                <check-mark-svg></check-mark-svg>
              </div>
            </div>
          </card>

          <!-- Doctor and speciality selction moidal-->
          <modal :show.sync="SHOW_DOCTOR_SELECTION_MODAL" headerclasses="justify-content-center"
            @close="onDoctorSelectionModalClosed()">
            <h6 slot="header" class="title title-up">{{ $t('message.Select a Doctor') }}</h6>
            <div class="row pl-3 pr-3">
              <div class="col-3" id="doctor-gender-dropdown">
                <drop-down tag="div" :icon="genderIconClass" titleClass="menu-text" position="left">
                  <a class="dropdown-item" @click="selectDoctorGender('all')"><i class="fa fa-users"></i> {{
                    $t("message.All Doctors") }}</a>
                  <a class="dropdown-item" @click="selectDoctorGender('male')"><i class="fa fa-male"></i>{{
                    $t("message.Male Doctors") }}</a>
                  <a class="dropdown-item" @click="selectDoctorGender('female')"><i class="fa fa-female"></i>{{
                    $t("message.Female Doctors") }}</a>
                </drop-down>
              </div>

              <div v-if="!SHOW_DOCTORS_OF_SPECIALITY" class="col-9 pl-0">
                <cool-select class="custom-input" :placeholder="$t('message.Search doctor by name, speciality or condition')" :items="doctors"
                  v-model="selectedDoctor" @search="searchDoctor" :resetSearchOnBlur="false" @keyup="coolSelectOnKeyUp"
                  ref="doctorSearch">
                  <template slot="no-data">
                    <div v-show="doctorSearchText && searchedDoctors && searchedDoctors.length < 1"> {{
                      $t("message.No doctors found") }}</div>
                  </template>
                </cool-select>
              </div>

            </div>

            <!-- online doctors -->
            <div class="row pl-3 pr-3" v-if="!SHOW_DOCTORS_OF_SPECIALITY && !IS_SCHEDULING && searchedDoctors.length < 1">
              <div class="col-12">
                <hr>
                <div>{{ $t("message.Online doctors") }}</div>
                <div style="align-items: center; overflow-y: scroll; overflow-x: hidden; max-height: 35vh; "
                  class="pl-3 pr-1">
                  <div class="row" v-for="doctor in onlineDoctors" :key="doctor._id"
                    @click="selectDoctor(doctor, 'Discussion')">
                    <div class="pr-1 col-11 autocomplete-result">
                      <div class="row">
                        <div class="col-2 pl-0 pr-0">
                          <profile-image v-if="doctor.profileImage" :file-id="doctor.profileImage"
                            :image-style="doctor.status == 'online' ? 'border-radius: 50%; border: 4px solid; vertical-align: middle; width: 50px; height: auto; aspect-ratio:1; border-radius: 50%; borderColor: #18ce0f' : (doctor.status == 'inAppointment' ? 'border-radius: 50%; border: 4px solid; vertical-align: middle; width: 50px; height: auto; aspect-ratio:1; border-radius: 50%; borderColor: darkorange' : 'border-radius: 50%; border: 4px solid; vertical-align: middle; width: 50px; height: auto; aspect-ratio:1; border-radius: 50%; borderColor: #888')"></profile-image>
                          <i class="fa fa-user-md text-center" v-if="!doctor.profileImage"
                            style="background: #888; padding: 10px; border-radius: 50%; color: #fff; border: 4px solid; width: 50px; height: 50px; font-size: large;"
                            :style="doctor.status == 'online' ? { borderColor: '#18ce0f' } : (doctor.status == 'inAppointment' ? { borderColor: 'darkorange' } : { borderColor: '#888' })"></i>
                        </div>
                        <div class="col-10">
                          <div class="row">
                            <div class="col-8 pr-0">
                              <div style="margin-bottom:0px; text-transform: none; font-size: 16px; font-weight: 600"
                                class="item-name">
                                {{ doctor.firstName }} {{ doctor.lastName }}
                              </div>
                              <div style="line-height:normal; font-size:12px;">{{ doctor.specialityText || "--" }}</div>
                            </div>

                            <!-- <div v-if="doctor.billingDetails && doctor.billingDetails.enabled && doctor.billingDetails.amount" style="font-weight: 700; display: flex; align-items: center;" class="col-3 pr-0">
                              <div>
                                <i :class="getCurrencyClass(doctor.billingDetails.currency)"></i>
                                {{ doctor.billingDetails.amount }}
                              </div>
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pl-0 col-1"
                      style="color: #616060;display: flex;justify-content: center;align-items: center;">
                      <i class="now-ui-icons arrows-1_minimal-right"></i>
                    </div>
                  </div>
                </div>
                <div style="font-size: 0.8em; text-align: center; margin-top: 1em;" v-if="onlineDoctors.length < 1">{{
                  $t("message.No doctors online") }}</div>
              </div>
            </div>

            <div class="row pl-3 pr-3" v-else>
              <div class="col-md-6 col-lg-4 d-flex" v-for="doctor in searchedDoctors" :key="doctor._id">
                <doctor-details-card :doctor="doctor" :hideBillingDetails="true">
                  <template v-slot:footer>
                    <div style="width: 100%;display: flex;justify-content: space-around;">
                      <n-button v-if="!IS_SCHEDULING" type="primary" round
                        @click.native="selectDoctor(doctor, 'Discussion')" class="mt-auto" style="width: fit-content">{{
                          $t("message.Choose Doctor") }}</n-button>
                      <!-- {{ $t("message.Select Slot") }} -->
                      <n-button v-if="IS_SCHEDULING" type="primary" round @click.native="openSlotSelection(doctor)"
                        class="mt-auto" style="width: fit-content">{{ $t("message.Choose Doctor") }}</n-button>
                    </div>
                  </template>
                </doctor-details-card>
              </div>

              <div class="col-12 pb-5" v-if="searchedDoctors && searchedDoctors.length > 0">
                <n-pagination v-if="totalPages > 1" :page-count="totalPages" v-model="pageNumber"></n-pagination>
              </div>
            </div>
            <div class="row pl-3 pr-3">
              <div v-if="!SHOW_DOCTORS_OF_SPECIALITY" class="col-12">
                <hr>
                <h4>{{ $t("message.Specialities") }}</h4>
              </div>

              <!-- List of specilaities -->
              <div class="col-12">
                <div v-if="!SHOW_DOCTORS_OF_SPECIALITY" class="row">
                  <div class="col-md-6 col-lg-3" v-for="speciality in specialities" :key="speciality._id">
                    <card style="
                        height: 100px;
                        cursor: pointer;
                        border-radius: 5px;
                        overflow: hidden;
                      " @click.native="getDoctorsOfSpeciality(speciality)">
                      <img v-if="!speciality.backgroundImage" src="@/assets/img/cardiology.jpg" style="
                          position: absolute;
                          top: 0px;
                          bottom: 0px;
                          left: 0px;
                          filter: brightness(50%);
                          height: 100%;
                          width: 100%;
                        " />
                      <dynamic-image v-if="speciality.backgroundImage" :file-id="speciality.backgroundImage" image-style="position: absolute;
                          top: 0px;
                          bottom: 0px;
                          left: 0px;
                          filter: brightness(50%);
                          height: 100%;
                          width: 100%;
                          background-size: cover;">
                      </dynamic-image>
                      <div class="row">
                        <div class="col-12 text-center">
                          <h6 class="card-title mt-3" style="color: #fff; font-size: larger">
                            {{ speciality.name }}
                          </h6>
                        </div>
                      </div>

                      <!-- <h6 class="card-subtitle mb-2 text-muted" style="font-size: smaller;">{{ doctor.specialityText || '--' }}</h6>
                <p class="card-text">{{ $t('message.waiting5') }}: {{ doctor.registration.number }}, {{ doctor.registration.city }}</p>-->
                      <p class="card-text">
                        {{ speciality.description || "--" }}
                      </p>
                      <!-- <a href="#" class="card-link" style="bottom: 0px;position: absolute;width: 100%">
                                    <n-button type="primary" round="">Book Appointment</n-button>
                </a>-->
                    </card>
                  </div>

                  <div class="col-12 pb-5" v-if="specialities && specialities.length > 0">
                    <n-pagination v-if="specialitiesPagination.totalPages > 1"
                      :page-count="specialitiesPagination.totalPages"
                      v-model="specialitiesPagination.pageNumber"></n-pagination>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="row" style="width: 100%" v-if="SHOW_DOCTORS_OF_SPECIALITY == true">
                  <div class="col-1" @click="SHOW_DOCTORS_OF_SPECIALITY = false">
                    <i class="now-ui-icons arrows-1_minimal-left"></i>
                  </div>
                  <div class="col-6">
                    <h6 v-if="selectedSpeciality" style="line-height: 21px">
                      {{ selectedSpeciality.name }}
                    </h6>
                  </div>
                  <div class="col-5" v-if="specialityDoctors.length > 0">
                    <n-button style="width:12em;" type="primary" round @click.native="selectSpeciality()">
                      {{ $t("message.Select Speciality") }}
                    </n-button>
                  </div>
                </div>
              </div>

              <!-- List of doctors of selected speciality -->
              <div class="col-12">
                <div v-if="SHOW_DOCTORS_OF_SPECIALITY" class="row">
                  <div class="col-md-6 col-lg-4 d-flex" v-for="doctor in specialityDoctors" :key="doctor._id">
                    <doctor-details-card :doctor="doctor" :hideBillingDetails="true">
                      <template v-slot:footer>
                        <div style="width: 100%;display: flex;justify-content: space-around;">
                          <n-button v-if="!IS_SCHEDULING" type="primary" round
                            @click.native="selectDoctor(doctor, 'Discussion')" class="mt-auto"
                            style="width: fit-content">{{ $t("message.Choose Doctor") }}</n-button>
                          <!-- {{ $t("message.Select Slot") }} -->
                          <n-button v-if="IS_SCHEDULING" type="primary" round @click.native="openSlotSelection(doctor)"
                            class="mt-auto" style="width: fit-content">{{ $t("message.Choose Doctor") }}</n-button>
                        </div>
                      </template>
                    </doctor-details-card>
                  </div>

                  <div class="col-12 pb-5 text-center" v-if="specialityDoctors.length < 1">
                    <div class="row">
                      <div class="col-12">
                        <i style="color: #fff; font-size: large">{{
                          $t("message.No doctors available for this speciality")
                        }}</i>
                      </div>
                      <div class="col-12">
                        <doctor-patient-svg style="height: 10em; width: 100%; margin-top: 20em"></doctor-patient-svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </modal>

          <!-- Doctor slot selction modal-->
          <modal :show.sync="SHOW_SLOT_SELECTION" headerclasses="justify-content-center">
            <h6 slot="header" class="title title-up">{{ $t('message.Select a slot') }}</h6>

            <slot-selection v-if="doctorForSlotSelection" :doctor-id="doctorForSlotSelection._id"
              @slot-selected="onSlotSelected"></slot-selection>
          </modal>
        </div>
      </transition>

      <!-- Speciality details -->
      <transition enter-active-class="slideInUp">
        <card v-if="SPECIALITY_SELECTED">
          <div slot="header">
            <div class="row">
              <div class="col-8">
                <h4 slot="header" class="card-title">
                  {{ $t("message.Speciality Details") }}
                </h4>
                <small>
                  <i>{{ $t("message.Consultation will be assigned to this speciality") }}</i>
                </small>
              </div>
              <div class="col-4 text-right pt-2">
                <i class="fa fa-edit fa-2x text-muted" style="font-weight: 100" @click="showDoctorSelectionModal()"></i>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-1">
              <i class="fa fa-certificate" style="
                  background: var(--color-primary);
                  padding: 10px;
                  border-radius: 50%;
                  color: #fff;
                "></i>
            </div>
            <div class="col-11">
              <h6 class="card-title mt-3" style="line-height: 2px">
                {{ selectedSpeciality.name }}
              </h6>
            </div>
          </div>

          <div class="row">
            <div class="col-1"></div>
            <div class="col-11">
              <h6 class="card-subtitle mb-2 text-muted" style="font-size: smaller">
                {{ selectedSpeciality.description || "--" }}
              </h6>
            </div>
          </div>

          <div class="col-12 text-center">
            <check-mark-svg></check-mark-svg>
          </div>
        </card>
      </transition>

      <transition enter-active-class="slideInUp">
        <div class="col-12 text-center" v-if="DOCTOR_SELECTED || SPECIALITY_SELECTED">
          <!-- <n-button type="primary" round size="lg" @click.native="startConsult()" id="btn-start-consulting">
            <h6 class="m-0">
              {{
                $t("message.Next")
              }}
            </h6>
          </n-button> -->
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import KhaltiCheckout from "khalti-checkout-web";
import { AllInOneSDK } from "@ionic-native/all-in-one-sdk/ngx";
import { Checkbox } from "src/components";

import DoctorPatientSvg from "../components/svg_images/DoctorPatientSvg.vue";

export default {
  name: "create-appointment",

  components: {
    DoctorPatientSvg,
    Checkbox,
  },

  data() {
    return {
      signaturePadOptions: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      signed: false,
      signaturePadDisabled: false,

      appointment: {
        patient: {
          mobileNumber: "",
        },
        priority: "low",
        scheduledTimestamp: {
          start: "",
          end: "",
        },
        reason: "",
      },
      mobileNumber: null,
      patients: [],
      patientSearchText: null,
      genderIconClass: "fa fa-users",
      doctorGenderFilter: "",
      ageUnit: "years",
      patientAge: null,
      patientAgeYears: null,
      patientAgeMonths: null,
      PATIENT_SELECTED: false,
      isValidMobile: false,
      NEW_PATIENT: false,
      APPT_DETAILS_ENTERED: false,
      SHOW_DOCTOR_SELECTION_MODAL: true,
      DOCTOR_SELECTED: false,
      doctors: [],
      onlineDoctors: [],
      selectedDoctor: null,
      searchedDoctors: [],
      specialities: [],
      specialitiesPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 12,
      },
      SHOW_DOCTORS_OF_SPECIALITY: false,
      specialityDoctors: [],
      selectedSpeciality: null,
      READY_TO_START: false,
      SPECIALITY_SELECTED: false,
      SHOW_PAYMENT_GATEWAY: false,
      COUPON_CODE_APPLIED: false,
      couponCode: null,
      IS_COUPON_CODE_ERR: false,
      couponErrorMessage: "",
      SHOW_SLOT_SELECTION: false,
      doctorForSlotSelection: null,
      patientProfileImage: null,
      createPatientBtnFixed: false,
      IS_SCHEDULING: false,
      doctorSearchText: null,
      doctorSearchMale: false,
      doctorSearchFemale: false,
    };
  },

  computed: {
    modelValidations() {
      return {
        firstName: {
          required: true,
        },
        lastName: {
          required: true,
        },
        email: {
          email: true,
        },
        gender: {
          required: true,
        },
        age: {
          required: true,
          min_value: 1,
          max_value: this.ageUnit == "years" ? 120 : 11,
        },
      };
    },
    userDetails() {
      return this.$store.state.userDetails;
    },
    settings() {
      return this.$store.state.settings;
    },
    endpoint() {
      return this.$store.state.endpoint;
    },
    BILLING_ENABLED() {
      return (
        this.settings.billingEnabled &&
        this.selectedDoctor &&
        this.selectedDoctor.billingDetails.enabled &&
        this.selectedDoctor.billingDetails.amount
      );
    },
    appointmentDate() {
      return moment(parseInt(this.appointment.scheduledTimestamp.start)).format(
        "DD-MM-YYYY"
      );
    },
    appointmentTime() {
      return moment(parseInt(this.appointment.scheduledTimestamp.start)).format(
        "h:mm A"
      );
    },
  },

  async mounted() {
    try {
      let response = await this.$store.dispatch("getSpecialities", {
        pageNumber: this.specialitiesPagination.pageNumber,
        pageSize: this.specialitiesPagination.pageSize,
      });
      this.specialities = response.data;
      this.specialitiesPagination.totalPages = response.totalPages;
      if (typeof this.user.endpoint == "string") {
        await this.$store.dispatch("getEndpoint", this.user.endpoint);
      }

      this.getOnlineDoctors();
    } catch (e) {
      console.log(e);
    }
  },

  methods: {
    async showDoctorSelectionModal() {
      this.SHOW_DOCTOR_SELECTION_MODAL = true;
      await this.getOnlineDoctors();
    },
    changeToUpperCase() {
      this.couponCode = this.couponCode.toUpperCase();
    },
    clearSignaturePad() {
      this.$refs.signature.clear();
    },
    validateStep() {
      return this.$validator.validateAll((isValid) => { });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async applyCouponCode() {
      try {
        if (this.couponCode) {
          this.appointment = await this.$store.dispatch("applyCoupon", {
            mobileNumber: this.appointment.patient.mobileNumber,
            couponCode: this.couponCode,
            appointmentId: this.appointment._id,
          });

          this.COUPON_CODE_APPLIED = true;
          this.IS_COUPON_CODE_ERR = false;
        }
      } catch (e) {
        console.log(e.response);
        // CP001 for negative value of discount
        if (e.response.data.errorCode == "CP001") {
          this.couponErrorMessage = this.$t("message.Billing Amount too low for the coupon to be applied");
        } else {
          this.couponErrorMessage = this.$t("message.Oops! Coupon could not be applied");
        }
        this.IS_COUPON_CODE_ERR = true;
      }
    },
    async applyCoupon() {
      if (this.appointment && this.appointment._id) {
        this.applyCouponCode();
      } else {
        let appointment = await this.createAppointment();
        if (appointment && appointment._id) {
          this.applyCouponCode();
        } else {
          this.couponErrorMessage = this.$t("message.Oops! Coupon could not be applied");
          this.IS_COUPON_CODE_ERR = true;
        }
      }
    },
    async removeCoupon() {
      try {
        this.appointment = await this.$store.dispatch("removeCoupon", {
          mobileNumber: this.appointment.patient.mobileNumber,
          couponCode: this.couponCode,
          appointmentId: this.appointment._id,
        });

        this.couponCode = null;
        this.COUPON_CODE_APPLIED = false;
      } catch (e) {
        console.log(e);
      }
    },

    async searchPatients(searchString) {
      try {
        if (searchString.length > 2) {
          this.patients = await this.$store.dispatch("searchPatients", {
            query: searchString,
            pageSize: 20,
          });
          if (this.patients.length > 0) {
            this.createPatientBtnFixed = true;
          }
        } else {
          this.patients = [];
          this.createPatientBtnFixed = false;
        }
      } catch (e) {
        console.log(e);
      }
    },
    selectPatient(patient) {
      this.patients = [];

      //Clear mobile number field
      this.appointment.patient.mobileNumber = "";
      this.appointment.patient.patientId = patient.patientId;
      this.appointment.patient.firstName = patient.firstName;
      this.appointment.patient.lastName = patient.lastName;

      if (patient.profileImage) {
        this.patientProfileImage = patient.profileImage;
      }

      var m = moment(patient.dob);
      var years = moment().diff(m, "years", false);
      this.patientAge = years;
      m = moment(m).add(years, "years");
      this.patientAgeMonths = moment().diff(m, "months", false);

      if (patient.gender == "female") {
        this.selectDoctorGender(patient.gender);
      }

      if (this.patientAgeYears < 1) {
        this.ageUnit = "months";
        this.patientAge = months;
      } else {
        this.ageUnit = "years";
        this.patientAge = years;
      }

      this.appointment.patient.gender = patient.gender;
      this.appointment.patient.history = patient.history;
      this.appointment.patient.email = patient.email;
      this.appointment.patient.mobileNumber =
        patient.mobileNumber && patient.mobileNumber.replace(/ /g, "");

      if (this.appointment.patient.mobileNumber) {
        this.mobileNumber = this.appointment.patient.mobileNumber;
      }

      this.appointment.patient.additionalInfo = patient.additionalDetails
        ? patient.additionalDetails
        : {};
      this.appointment.patient.provider = patient.provider;
      this.addPatientEnable = false;
      if (this.error) this.error = "";
      this.PATIENT_SELECTED = true;
      this.createPatientBtnFixed = false;
    },
    mobileNumberUpdate(payload) {
      this.isValidMobile = payload.isValid;
      this.appointment.patient.mobileNumber = payload.formattedNumber;
    },
    calculateDob() {
      if (this.ageUnit == "years") {
        this.patientAgeMonths = null;
        this.patientAgeYears = this.patientAge;
      }

      if (this.ageUnit == "months") {
        this.patientAgeYears = null;
        this.patientAgeMonths = this.patientAge;
      }

      let currentYear = new Date().getUTCFullYear();
      let yearOFBirth = currentYear - (this.patientAgeYears || 0);

      let currentMonth = new Date().getMonth() + 1;
      let monthOfBirth = currentMonth - (this.patientAgeMonths || 0);

      if (monthOfBirth == 0 || Math.sign(monthOfBirth) == -1) {
        --yearOFBirth;
        monthOfBirth = 12 + monthOfBirth;
      }
      this.appointment.patient.dob = monthOfBirth + "/01/" + yearOFBirth;
    },
    resetPatientSelection() {
      this.appointment.patient.firstName = null;
      this.appointment.patient.lastName = null;
      this.appointment.patient.gender = null;
      this.appointment.patient.dob = null;
      this.appointment.patientAgeYears = null;
      this.appointment.patientAgeMonths = null;
      this.appointment.patient.email = null;
      this.appointment.patient.mobileNumber = null;
      this.appointment.patient.history = null;
      this.appointment.patient.patientId = null;
      this.patientProfileImage = null;
      this.patientAgeMonths = null;
      this.patientAgeYears = null;
      this.patientAge = null;
      this.mobileNumber = null;

      this.PATIENT_SELECTED = false;
      this.NEW_PATIENT = false;
      this.APPT_DETAILS_ENTERED = false;

      //Clearing the details to make the step count is in sync and allowing to re-enter details.
      this.selectedDoctor = null;
      this.DOCTOR_SELECTED = false;
      this.SPECIALITY_SELECTED = false;
      this.signed = false;
      this.signaturePadDisabled = false;
      this.SHOW_PAYMENT_GATEWAY = false;

      this.stepper.completed = 0;
    },
    validateAppointmentDetails() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.APPT_DETAILS_ENTERED = true;

          setTimeout(() => {
            this.scrollTo("wrapper");
          }, 500);
        }
      });
    },
    validatePatientDetails() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.PATIENT_SELECTED = true;
          this.createPatientBtnFixed = false;
        }
      });
    },
    selectDoctorGender(gender) {
      if (gender == "male") {
        this.doctorGenderFilter = "male";
        this.genderIconClass = "fa fa-male";
      } else if (gender == "female") {
        this.doctorGenderFilter = "female";
        this.genderIconClass = "fa fa-female";
      } else if (gender == "all") {
        this.doctorGenderFilter = "";
        this.genderIconClass = "fa fa-users";
      }
      if (this.SHOW_DOCTORS_OF_SPECIALITY) {
        this.getDoctorsOfSpeciality(this.selectedSpeciality);
      } else {
        this.searchDoctor(this.doctorSearchText);
        this.getOnlineDoctors();
      }
    },

    async getOnlineDoctors() {
      let query = {};
      query.availableFor = "availableForDiscussion";
      if (this.doctorGenderFilter) {
        query.gender = this.doctorGenderFilter;
      }
      if (
        this.settings &&
        this.settings.locationSensitivity &&
        this.user &&
        this.user.location
      ) {
        query.location = this.user.location;
      }
      if (
        this.settings &&
        this.settings.specialitySensitivity &&
        this.user &&
        this.user.speciality
      ) {
        query.speciality = JSON.stringify(
          this.user.speciality.map((speciality) => speciality._id)
        );
      }
      this.onlineDoctors = (
        await this.$store.dispatch("getOnlineDoctors", query)
      ).data.data;
    },
    async searchDoctor(searchString) {
      try {
        this.doctorSearchText = searchString;
        this.searchedDoctors = [];
        let query = {
          searchString: searchString,
        };
        query.availableFor = "availableForDiscussion";

        if (this.doctorGenderFilter) {
          query.gender = this.doctorGenderFilter;
        }

        if (
          this.settings &&
          this.settings.locationSensitivity &&
          this.user &&
          this.user.location
        ) {
          query.location = this.user.location;
        }
        if (
          this.settings &&
          this.settings.specialitySensitivity &&
          this.user &&
          this.user.speciality
        ) {
          query.speciality = JSON.stringify(
            this.user.speciality.map((speciality) => speciality._id)
          );
        }

        if (query.searchString) {
          let response = await this.$store.dispatch("searchDoctors", query);

          this.searchedDoctors = response.data;
          this.totalPages = response.totalPages;
        }
      } catch (e) {
        console.log(e);
      }
    },
    coolSelectOnKeyUp(event) {
      if (event.key == "Enter") {
        this.$refs.doctorSearch.$el.querySelector("input").blur();
      }
    },
    async selectDoctor(doctor, appointmentType) {
      //If speciality was selected before, undo it
      this.SPECIALITY_SELECTED = false;

      //resetting the properties when doctor selection is edited
      this.SHOW_PAYMENT_GATEWAY = false;
      this.READY_TO_START = false;

      this.selectedSpeciality = null;
      this.appointment.specialityId = "";
      this.appointment.specialityText = "";

      if (appointmentType == "Discussion") {
        this.appointment.appointmentType = "Discussion";
        this.appointment.scheduledTimestamp = {};
      }

      this.appointment.provider = {};
      this.appointment.provider.providerId = doctor._id;
      this.appointment.provider.username = doctor.username;
      this.appointment.provider.firstName = doctor.firstName;
      this.appointment.provider.lastName = doctor.lastName;
      this.appointment.provider.fullName =
        doctor.firstName + " " + doctor.lastName;
      this.appointment.provider.fullName =
        doctor.firstName + " " + doctor.lastName;
      this.appointment.provider.specialityText = doctor.specialityText;
      this.appointment.provider.slots = doctor.slots;
      this.appointment.provider.timezone = doctor.timezone;
      this.appointment.provider.description = doctor.description;
      this.appointment.provider.UIN = doctor.UIN;
      this.appointment.provider.email = doctor.email;

      let doctorEp = null;
      for (let ep of doctor.endpoints) {
        if (ep.isDefault && ep.name) {
          doctorEp = ep.name;
          break;
        }
      }

      if (doctorEp) {
        this.appointment.provider.endpoint = doctorEp;
      }

      //Billing details
      this.appointment.billingDetails = {};
      this.appointment.billingDetails.currency = doctor.billingDetails.currency;

      //Calculate amount based on endpoints configuration
      //Consider doctor's billing amount only if billing is enabled for the doctor
      if (
        this.settings.paymentSettings &&
        this.settings.paymentSettings.nurseCommission &&
        this.settings.paymentSettings.nurseCommission.enabled
      ) {
        this.appointment.billingDetails.amount = doctor.billingDetails.amount;
      } else {
        this.appointment.billingDetails.amount = this.getCalculatedAmount(
          this.settings.billingEnabled && doctor.billingDetails.enabled
            ? doctor.billingDetails.amount
            : 0
        );
      }

      this.selectedDoctor = doctor;
      this.SHOW_DOCTOR_SELECTION_MODAL = false;
      this.DOCTOR_SELECTED = true;

      await this.onDoctorOrSpecialitySelection();
      this.startConsult();
    },
    openSlotSelection(doctor) {
      this.doctorForSlotSelection = doctor;
      this.SHOW_SLOT_SELECTION = true;
    },
    onSlotSelected(slot) {
      this.appointment.appointmentType = "Scheduled";
      this.appointment.scheduledTimestamp = {
        start: slot.start,
        end: slot.end,
      };
      this.selectDoctor(this.doctorForSlotSelection);
      this.SHOW_SLOT_SELECTION = false;
      this.SHOW_DOCTOR_SELECTION_MODAL = false;
    },
    async onDoctorOrSpecialitySelection() {
      this.onDoctorSelectionModalClosed();
      this.READY_TO_START = true;
      setTimeout(() => {
        this.scrollTo("wrapper");
      }, 500);
    },
    onDoctorSelectionModalClosed() {
      this.specialityDoctors = [];
      this.searchedDoctors = [];
      this.SHOW_DOCTORS_OF_SPECIALITY = false;
    },
    getCalculatedAmount(value) {
      if (
        this.endpoint &&
        this.endpoint.billingDetails.enabled &&
        this.endpoint.billingDetails.pricingType &&
        this.endpoint.billingDetails.value
      ) {
        switch (this.endpoint.billingDetails.pricingType) {
          case "fixedPrice":
            return this.endpoint.billingDetails.value;
            break;
          case "fixedMargin":
            return (
              parseInt(value) + parseInt(this.endpoint.billingDetails.value)
            );
            break;
          case "percentageMargin":
            return (
              parseInt(value) +
              parseInt(value) *
              (parseInt(this.endpoint.billingDetails.value) / 100)
            );
            break;
          default:
            return value;
        }
      } else {
        return value;
      }
    },

    //getting nurse margin to add to credit earnings
    getNurseMargin(value) {
      if (
        this.endpoint &&
        this.endpoint.billingDetails.enabled &&
        this.endpoint.billingDetails.pricingType &&
        this.endpoint.billingDetails.value
      ) {
        switch (this.endpoint.billingDetails.pricingType) {
          case "fixedMargin":
            return parseInt(this.endpoint.billingDetails.value);
          case "percentageMargin":
            return (
              parseInt(value) *
              (parseInt(this.endpoint.billingDetails.value) / 100)
            );
          default:
            return 0;
        }
      } else {
        return 0;
      }
    },

    creditPointsAvailable() {
      let nurseCommission = 0;
      let type = "appointment";
      if (
        this.endpoint &&
        this.endpoint.commissionDetails &&
        this.endpoint.commissionDetails.enabled &&
        this.endpoint.commissionDetails[type].enabled &&
        this.endpoint.commissionDetails[type].pricingType &&
        this.endpoint.commissionDetails[type].value
      ) {
        switch (this.endpoint.commissionDetails[type].pricingType) {
          case "fixedPrice":
            nurseCommission = this.endpoint.commissionDetails[type].value;
            break;
          case "fixedMargin":
            nurseCommission = parseInt(
              this.endpoint.commissionDetails[type].value
            );
            break;
          case "percentageMargin":
            nurseCommission =
              parseInt(this.appointment.billingDetails.amount) *
              (parseInt(this.endpoint.commissionDetails[type].value) / 100);
            break;
          default:
            nurseCommission = 0;
        }
      } else {
        nurseCommission = 0;
      }

      let requiredCredits =
        this.appointment.billingDetails.amount - nurseCommission;

      return this.userDetails.credits >= requiredCredits;
    },

    async startConsult() {
      let loader = this.$loading.show();

      try {
        //If appointment already created, show alert and join appointment
        if (this.appointment._id) {
          this.showAppointmentCreationAlert();
        } else {
          this.appointment.consultationType = "telemedicine";
          this.creatingAppointment = true;

          if (this.NEW_PATIENT) {
            this.createPatient(async (err, patient) => {
              if (patient) {
                this.appointment.patient.patientId = patient.patientId;
                this.setAppointmentDetails();
                await this.createAppointment();
                this.showAppointmentCreationAlert();
              }
            });
          } else {
            //Saving mobilenumber as patientID if 'Add patient details' is not checked
            if (!this.appointment.patient.patientId) {
              this.appointment.patient.patientId =
                this.appointment.patient.mobileNumber;
            }

            this.setAppointmentDetails();
            await this.createAppointment();
            this.showAppointmentCreationAlert();
          }
        }
      } catch (e) {
        console.log(e);
        swal.fire({
          type: "error",
          text: this.$t("message.Could not start the appointment"),
          timer: 5000,
        });
      }
      loader.hide();
    },
    isDisclaimerEnabled() {
      if (
        this.endpoint &&
        this.endpoint.disclaimer &&
        this.endpoint.disclaimer.enabled &&
        this.settings.disclaimer &&
        this.settings.disclaimer.enabled
      ) {
        let disclaimer = this.endpoint.disclaimer;

        if (disclaimer.enabledForTelemed) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    async getDoctorsOfSpeciality(speciality) {
      this.selectedSpeciality = speciality;
      this.SHOW_DOCTORS_OF_SPECIALITY = true;
      let query = {
        specialityId: speciality._id,
      };
      if (this.doctorGenderFilter) {
        query.gender = this.doctorGenderFilter;
      }
      query.availableFor = "availableForDiscussion";
      if (
        this.settings &&
        this.settings.locationSensitivity &&
        this.user &&
        this.user.location
      ) {
        query.location = this.user.location;
      }
      if (
        this.settings &&
        this.settings.specialitySensitivity &&
        this.user &&
        this.user.speciality
      ) {
        query.speciality = JSON.stringify(
          this.user.speciality.map((speciality) => speciality._id)
        );
      }
      try {
        let response = await this.$store.dispatch(
          "getDoctorsBySpeciality",
          query
        );
        this.specialityDoctors = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async selectSpeciality() {
      //If doctor was selected before, undo it
      this.DOCTOR_SELECTED = false;
      this.selectedDoctor = null;
      this.appointment.provider = {};
      this.appointment.appointmentTime = "";
      this.appointment.slots = "";

      this.appointment.specialityId = this.selectedSpeciality._id;
      this.appointment.specialityText = this.selectedSpeciality.name;
      this.SHOW_DOCTOR_SELECTION_MODAL = false;
      this.SPECIALITY_SELECTED = true;
      // this.APPT_DETAILS_ENTERED = true;

      this.onDoctorOrSpecialitySelection();
    },
    async createPatient(cb) {
      try {
        var patient = {
          firstName: this.appointment.patient.firstName,
          lastName: this.appointment.patient.lastName,
          mobileNumber: this.appointment.patient.mobileNumber,
          roles: ["patient"],
          dob: moment.utc(this.appointment.patient.dob),
          email: this.appointment.patient.email,
          password: moment(this.appointment.patient.dob).format("ddMMyyyy"),
          history: this.appointment.patient.history,
          gender: this.appointment.patient.gender,
          additionalDetails: this.appointment.patient.additionalInfo,
          patientId: this.appointment.patient.patientId,
        };

        let response = await this.$store.dispatch("createPatient", patient);
        cb(null, response);
      } catch (e) {
        console.log(e);
        swal
          .fire({
            type: "error",
            title: this.$t("message.Could not create the patient record"),
            timer: 5000,
          })
          .then(() => {
            this.$router.push("/nursehome");
          });
      }
    },
    async checkIfEmrIdIsTaken(cb) {
      try {
        await this.$store.dispatch(
          "getPatientByPatientId",
          this.appointment.patient.patientId
        );
        cb(true);
      } catch (e) {
        console.log(e);
        if (e.unique) {
          cb(false);
        } else {
          cb(true);
        }
      }
    },
    async setAppointmentDetails() {
      this.appointment.attendant = {};
      this.appointment.attendant.firstName = this.user.firstName;
      this.appointment.attendant.lastName = this.user.lastName;
      this.appointment.attendant.username = this.user.username;

      //Set appointment type
      if (
        this.appointment.scheduledTimestamp &&
        this.appointment.scheduledTimestamp.start
      ) {
        this.appointment.appointmentType = "Scheduled";
      } else {
        this.appointment.appointmentType = "Discussion";
      }

      //If billing is enabled, dont book appointment. Instead create a blocked appointment and then confirm after payment
      if (this.appointment.appointmentType == "Discussion") {
        if (this.BILLING_ENABLED) {
          this.appointment.appointmentStatus = [
            {
              status: "Blocked",
              timestamp: new Date().getTime(),
            },
          ];
          this.appointment.latestStatus = "Blocked";
        } else {
          this.appointment.appointmentStatus = [
            {
              status: "Created",
              timestamp: new Date().getTime(),
            },
          ];
          this.appointment.latestStatus = "Created";
        }
      } else if (this.appointment.appointmentType == "Scheduled") {
        if (this.BILLING_ENABLED) {
          this.appointment.appointmentStatus = [
            {
              status: "Blocked",
              timestamp: new Date().getTime(),
            },
          ];
          this.appointment.latestStatus = "Blocked";
        } else {
          this.appointment.appointmentStatus = [
            {
              status: "Created",
              timestamp: new Date().getTime(),
            },
          ];
          this.appointment.latestStatus = "Created";
        }
      }

      if (this.appointment.consultationType == "checkup") {
        this.appointment.appointmentStatus.push({
          status: "InProgress",
          timestamp: new Date().getTime(),
        });

        this.appointment.latestStatus = "InProgress";
      }

      this.appointment.createdBy = "nurse";

      if (this.appointment.appointmentDate) {
        this.appointment.appointmentDate.timestamp = moment(
          this.appointment.appointmentDate.date
        ).valueOf();
        this.appointment.appointmentDate.date = moment.utc(
          this.appointment.appointmentDate.date
        );
        this.appointment.appointmentDate.timeZone = moment.tz.guess();
      }
      if (this.appointment.patient.dob)
        this.appointment.patient.dob = moment.utc(this.appointment.patient.dob);
      this.appointment.startTime = "";

      // this.appointment.endpoint = this.endpoint.name;
    },
    async createAppointment() {
      try {
        this.appointment = await this.$store.dispatch(
          "createNurseAppointment",
          this.appointment
        );
        return this.appointment;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async confirmAppointment() {
      if (
        this.COUPON_CODE_APPLIED &&
        this.appointment.billingDetails.amount == 0
      ) {
        this.$store.dispatch("markAppointmentAsPaid", this.appointment._id);
      }

      let that = this;
      if (this.NEW_PATIENT) {
        this.createPatient(async (err, patient) => {
          if (patient) {
            that.appointment.patient.patientId = patient.patientId;
            that.showAppointmentCreationAlert();
            this.READY_TO_START = true;
          }
        });
      } else {
        this.showAppointmentCreationAlert();
        this.READY_TO_START = true;
      }
    },
    async initiatePayment() {
      console.log("settings : ", this.settings);
      if (this.appointment && this.appointment._id) {
        if (
          this.settings.paymentSettings.razorpay.enabled &&
          this.settings.paymentPreferences.appointments.razorpay.enabled &&
          RazorpayCheckout
        ) {
          this.initiateRazorPayPayment();
        } else if (
          this.settings.paymentSettings.khalti.enabled &&
          this.settings.paymentPreferences.appointments.khalti.enabled
        ) {
          this.initiateKhaltiPayment();
        } else if (
          this.settings.paymentSettings.paytm.enabled &&
          this.settings.paymentPreferences.appointments.paytm.enabled
        ) {
          this.initiatePaytmPayment();
        } else {
          swal.fire(this.$t("message.Error with payment method"));
        }
      } else {
        let appointment = await this.createAppointment();
        if (appointment && appointment._id) {
          if (
            this.settings.paymentSettings.razorpay.enabled &&
            this.settings.paymentPreferences.appointments.razorpay.enabled &&
            RazorpayCheckout
          ) {
            this.initiateRazorPayPayment();
          } else if (
            this.settings.paymentSettings.khalti.enabled &&
            this.settings.paymentPreferences.appointments.khalti.enabled
          ) {
            this.initiateKhaltiPayment();
          } else if (
            this.settings.paymentSettings.paytm.enabled &&
            this.settings.paymentPreferences.appointments.paytm.enabled
          ) {
            this.initiatePaytmPayment();
          } else {
            swal.fire(this.$t("message.Error with payment method"));
          }
        } else {
          swal.fire({
            type: "error",
            title: this.$t("message.Could not create the appointment"),
            timer: 3000,
          });
        }
      }
    },
    async initiatePayThroughCredits() {
      if (this.appointment && this.appointment._id) {
        this.payThroughCredits();
      } else {
        let appointment = await this.createAppointment();
        if (appointment && appointment._id) {
          this.payThroughCredits();
        } else {
          swal.fire({
            type: "error",
            title: this.$t("message.Could not create the appointment"),
            timer: 3000,
          });
        }
      }
    },
    async payThroughCredits() {
      let loader = this.$loading.show();
      try {
        let transaction = await this.$store.dispatch("payUingCredits", {
          gateway: "creditPoints",
          appointmentId: this.appointment._id,
        });
        console.log(transaction);
        if (
          transaction &&
          transaction.latestStatus &&
          transaction.latestStatus == "Success"
        ) {
          if (
            !(
              this.endpoint &&
              this.endpoint.commissionDetails &&
              this.endpoint.commissionDetails.enabled
            )
          ) {
            try {
              let nurseMargin = this.getNurseMargin(
                this.settings.billingEnabled &&
                  this.selectedDoctor.billingDetails.enabled
                  ? this.selectedDoctor.billingDetails.amount
                  : 0
              );
              if (nurseMargin > 0) {
                console.log("adding credit earnings to the nurse");
                await this.$store.dispatch("addCreditEarnings", {
                  nurseMargin,
                  appointmentId: this.appointment._id,
                });
              }
            } catch (error) {
              console.log(error);
            }
          }

          this.appointment = await this.$store.dispatch("updateStatus", {
            appointmentId: this.appointment._id,
            status: "Created",
          });

          swal.fire({
            type: "success",
            title: this.$t("message.Payment successful!"),
            timer: 3000,
          });
          this.READY_TO_START = true;
        } else {
          throw new Error();
        }
        loader.hide();
      } catch (e) {
        console.log(e);
        loader.hide();
        swal.fire({
          type: "error",
          title: this.$t("message.Payment failed!"),
          timer: 5000,
        });
      }
    },
    async initiateRazorPayPayment() {
      let loader = this.$loading.show();
      let that = this;
      this.PAYMENT_INPROGRESS = true;
      let transaction = await this.$store.dispatch("initiatePayment", {
        gateway: "razorpay",
        appointmentId: this.appointment._id,
        patient: this.patient,
      });

      var options = {
        order_id: transaction.paymentDetails.orderId,
        description: this.settings.paymentSettings.razorpay.paymentDescription,
        key: this.settings.paymentSettings.razorpay.key_id,
        currency: transaction.paymentDetails.currency,
        amount: Number(transaction.paymentDetails.amount) * 100 + "",
        name: this.settings.paymentSettings.razorpay.name,
        image: "https://i.imgur.com/n5tjHFD.png",
        prefill: {
          name:
            this.appointment.patient.firstName +
            " " +
            this.appointment.patient.lastName,
          email:
            this.appointment.patient.email ||
            this.settings.directBookings.defaultEmail ||
            "",
          contact: this.appointment.patient.mobileNumber,
        },
        theme: {
          color:
            document.documentElement.style.getPropertyValue(
              "--color-primary"
            ) || "#f96332",
        },
      };

      if (this.settings.paymentSettings.razorpay.logoUrl) {
        options.image = this.settings.paymentSettings.razorpay.logoUrl;
      }

      window.razorpaySuccessCallback = async function (response) {
        response.appointmentId = that.appointment._id;
        response.razorpay_order_id = transaction.paymentDetails.orderId;
        try {
          let verificationResponse = await that.$store.dispatch(
            "verifyPayment",
            {
              gateway: "razorpay",
              transaction: response,
            }
          );

          if (
            verificationResponse &&
            verificationResponse.latestStatus == "Success"
          ) {
            //Send appointment notifications to patient only after payment success fix
            that.appointment = await that.$store.dispatch("updateStatus", {
              appointmentId: that.appointment._id,
              status: "Created",
            });
            loader.hide();
            swal.fire({
              type: "success",
              title: that.$t("message.Payment successful!"),
              timer: 3000,
            });
            that.READY_TO_START = true;
          } else {
            throw new Error("Payment failed");
          }
          loader.hide();
        } catch (e) {
          loader.hide();
          console.log(e);
          swal.fire({
            type: "error",
            title: that.$t("message.Payment failed!"),
            text: that.$t("message.Any consultation fees paid will be refunded within 7 working days"),
            timer: 5000,
          });
        }
      };

      window.razorpayCancelCallback = function (error) {
        console.log(error);
        that.$store.dispatch("updateStatus", {
          appointmentId: that.appointment._id,
          status: "Cancelled",
        });
        loader.hide();
        swal
          .fire({
            type: "error",
            title: that.$t("message.Payment failed!"),
            text: that.$t("message.Any consultation fees paid will be refunded within 7 working days"),
            timer: 5000,
          })
          .then(() => {
            that.$router.push("/nursehome");
          });
      };

      RazorpayCheckout.on("payment.success", window.razorpaySuccessCallback);
      RazorpayCheckout.on("payment.cancel", window.razorpaySuccessCallback);
      RazorpayCheckout.open(options);
    },
    async initiatePaytmPayment() {
      try {
        let that = this;
        this.PAYMENT_INPROGRESS = true;
        let allInOneSDK = new AllInOneSDK();
        let loader = this.$loading.show();

        //Call Initiate Transaction API from your backend to generate Transaction Token.
        let transaction = await this.$store.dispatch("initiatePayment", {
          gateway: "paytm",
          appointmentId: this.appointment._id,
          patient: this.appointment.patient,
          //send resposnse from the above step
        });

        let isStaging =
          that.settings.paymentSettings.paytm.callbackUrl.includes("stage");

        // constructor(private allInOneSDK : AllInOneSDK) {}
        let paymentIntent = {
          mid: that.settings.paymentSettings.paytm.mid,
          orderId: transaction.paymentDetails.orderId,
          txnToken: transaction.paymentDetails.txnToken, //"<Transaction Token generated by Initiate Transaction API from your backend>",
          amount: transaction.paymentDetails.amount,
          isStaging: isStaging,
          callbackUrl:
            that.settings.paymentSettings.paytm.callbackUrl +
            "?ORDER_ID=" +
            transaction.paymentDetails.orderId,
          restrictAppInvoke: isStaging,
          enableAssist: true,
        };

        allInOneSDK
          .startTransaction(paymentIntent)
          .then(async (resp) => {
            // The response received after the transaction is completed will be an object containing "message" and "response". You can parse both and use them as required in your application
            // alert(JSON.parse(resp.response));
            let response = JSON.parse(resp.response);

            if (response.STATUS == "TXN_SUCCESS") {
              try {
                response.appointmentId = that.appointment._id;
                response.transactionId = transaction._id;
                let verificationResponse = await that.$store.dispatch(
                  "verifyPayment",
                  {
                    gateway: "paytm",
                    transaction: response,
                  }
                );
                if (
                  verificationResponse &&
                  verificationResponse.latestStatus == "Success"
                ) {
                  //Send appointment notifications to patient only after payment success fix
                  that.appointment = await that.$store.dispatch(
                    "updateStatus",
                    {
                      appointmentId: that.appointment._id,
                      status: "Created",
                    }
                  );
                  loader.hide();
                  swal.fire({
                    type: "success",
                    title: that.$t("message.Payment successful!"),
                    timer: 3000,
                  });
                  that.READY_TO_START = true;
                } else {
                  that.PAYMENT_INPROGRESS = false;
                  throw new Error("Payment failed");
                }
              } catch (error) {
                console.error(error);
                throw new Error("Payment failed");
              }
            } else {
              // createappointment28
              that.PAYMENT_INPROGRESS = false;
              throw new Error("Payment failed");
            }
          })
          .catch((error) => {
            // alert(error);
            console.error(error);
            loader.hide();
            swal.fire({
              type: "error",
              title: that.$t("message.Payment failed!"),
              text: that.$t("message.Any consultation fees paid will be refunded within 7 working days"),
              timer: 5000,
            });
          });
        loader.hide();
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    async initiateKhaltiPayment() {
      let that = this;
      this.PAYMENT_INPROGRESS = true;
      let loader = this.$loading.show();
      let transaction = await this.$store.dispatch("initiatePayment", {
        gateway: "khalti",
        appointmentId: this.appointment._id,
        patient: this.appointment.patient,
      });

      let config = {
        publicKey: that.settings.paymentSettings.khalti.publicKey,
        productIdentity: that.appointment._id,
        productName: "Appointment",
        productUrl: window.location.href,
        eventHandler: {
          async onSuccess(response) {
            console.log(response);
            response.appointmentId = that.appointment._id;
            response.transactionId = transaction._id;
            let verificationResponse = await that.$store.dispatch(
              "verifyPayment",
              {
                gateway: "khalti",
                transaction: response,
                patient: that.appointment.patient,
              }
            );

            if (
              verificationResponse &&
              verificationResponse.latestStatus == "Success"
            ) {
              //Send appointment notifications to patient only after payment success fix
              that.appointment = await that.$store.dispatch("updateStatus", {
                appointmentId: that.appointment._id,
                status: "Created",
              });
              loader.hide();
              swal.fire({
                type: "success",
                title: that.$t("message.Payment successful!"),
                timer: 3000,
              });
              that.READY_TO_START = true;
            } else {
              that.PAYMENT_INPROGRESS = false;
              throw new Error("Payment failed");
            }
            loader.hide();
          },
          // onError handler is optional
          onError(error) {
            // handle errors
            that.PAYMENT_INPROGRESS = false;
            loader.hide();
            swal.fire(that.$t("message.Payment error"));
            console.log(error);
          },
          onClose() {
            loader.hide();
            that.PAYMENT_INPROGRESS = false;
          },
        },
        paymentPreference: [
          "KHALTI",
          "EBANKING",
          "MOBILE_BANKING",
          "CONNECT_IPS",
          "SCT",
        ],
      };

      let khaltiCheckout = new KhaltiCheckout(config);
      khaltiCheckout.show({
        amount: Number(transaction.paymentDetails.amount) * 100 + "",
      });
    },
    async checkEndpointStatus() {
      let ep = await this.$store.dispatch(
        "getEndpoint",
        this.user.endpoint.name
      );
      return ep.status;
    },

    async showAppointmentCreationAlert() {
      if (this.appointment && this.appointment._id) {
        if (this.appointment.latestStatus != "Created") {
          this.appointment = await this.$store.dispatch("updateStatus", {
            appointmentId: this.appointment._id,
            status: "Created",
          });
          this.$store.commit("setState", {
            stateName: "appointment",
            stateValue: this.appointment,
          });
        }
        if (this.appointment.appointmentType == "Discussion") {
          let endponitStatus = await this.checkEndpointStatus();
          // endponitStatus = "Busy";
          if (endponitStatus == "Busy") {
            swal
              .fire({
                title: this.$t("message.Endpoint Busy"),
                type: "info",
                closeOnConfirm: true,
              })
              .then(() => {
                this.$router.push({ path: "/nursehome" });
              });
          } else {
            //Assigning appointment on join
            this.appointment = await this.$store.dispatch("updateStatus", {
              appointmentId: this.appointment._id,
              status: "Assigned",
            });
            this.$store.commit("setState", {
              stateName: "appointment",
              stateValue: this.appointment,
            });
            if (
              this.appointment.provider &&
              this.appointment.provider.providerId
            ) {
              socket.emit("appointmentListUpdate", {
                providerId: this.appointment.provider.providerId,
                specialityId: this.appointment.specialityId,
              });
            } else {
              socket.emit("appointmentListUpdate", {
                specialityId: this.appointment.specialityId,
              });
            }

            this.$router.push({ path: "/telemeddiscussion" });
          }
        } else {
          swal
            .fire({
              title: this.$t("message.Appointment scheduled successfully!"),
              type: "success",
            })
            .then(() => {
              if (
                this.appointment.provider &&
                this.appointment.provider.providerId
              ) {
                socket.emit("appointmentListUpdate", {
                  providerId: this.appointment.provider.providerId,
                });
              }

              this.$router.push({ path: "/nursehome" });
            });
        }
      } else {
        swal.fire({
          type: "error",
          title: this.$t("message.Could not create the appointment"),
          timer: 5000,
        });
      }
    },
  },
  watch: {
    ageUnit: function () {
      this.calculateDob();
    },
    patientAge: function () {
      this.calculateDob();
    },
  },
};
</script>

<style scoped>
/* styles for the reason input */
/deep/#select-reason .IZ-select__input--focused input {
  margin-bottom: 0;
}

/deep/#doctor-gender-dropdown {
  text-align: center;
}

/deep/#doctor-gender-dropdown .dropdown-menu i {
  width: 1.2em;
  text-align: center;
}

/deep/#doctor-gender-dropdown .dropdown-item {
  padding-bottom: 0.5em;
  padding-top: unset;
  margin-top: unset;
  font-size: unset;
  text-align: start;
}

/deep/#select-reason .IZ-select__menu {
  padding: 0.2em 1em;
  border-radius: 1em;
  border: solid 0.5px #9a9a9a;
  box-shadow: 0px 2px 10px 2px #bdbdbd;
}

/deep/#select-reason .IZ-select__item {
  border-bottom: none;
  margin: 0.5em 0;
}

/deep/ #age-dropdown input {
  height: 40px;
  border-start-start-radius: 0;
  border-end-start-radius: 0;
  border-style: none;
  border-inline-start-style: solid;
  background-color: transparent !important;
  color: #9a9a9a;
}

/deep/ .IZ-select__item {
  border-bottom: 1px solid lightgrey;
}

.autocomplete-result {
  margin-top: 1em;
  margin-bottom: 1em;
}

/deep/ .modal-content .modal-body {
  padding-left: 0px;
  padding-right: 0px;
}

/deep/ .IZ-select__no-data {
  text-align: center;
}

/deep/ .modal-dialog {
  max-width: inherit;
}

/deep/.reason-icon {
  font-size: 0.8em;
  line-height: inherit;
}

/deep/.create-button-fixed {
  position: fixed;
  bottom: 0;
  inset-inline-end: 15%;
}

/deep/.patient-selection {
  height: calc(100% - 125px);
  overflow-y: scroll;
  overflow-x: hidden;
}

/deep/.float-input-label {
  position: absolute;
  font-size: 0.65em;
  padding-left: 2em;
  color: var(--color-primary);
  top: 0.2em;
}

/deep/.float-input-label.age {
  top: 0.9em;
}

#wrapper {
  scroll-behavior: smooth;
}
</style>
